"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isHotkey = _interopRequireDefault(require("is-hotkey"));

var _CommandsAndQueries = _interopRequireDefault(require("./CommandsAndQueries"));

var _List = _interopRequireDefault(require("./List"));

var _LineBreak = _interopRequireDefault(require("./LineBreak"));

var _BreakToDefaultBlock = _interopRequireDefault(require("./BreakToDefaultBlock"));

var _CloseBlock = _interopRequireDefault(require("./CloseBlock"));

var _QuoteBlock = _interopRequireDefault(require("./QuoteBlock"));

var _SelectAll = _interopRequireDefault(require("./SelectAll"));

var _CopyPasteVisual = _interopRequireDefault(require("./CopyPasteVisual"));

var _Link = _interopRequireDefault(require("./Link"));

var _ForceInsert = _interopRequireDefault(require("./ForceInsert"));

var _Shortcode = _interopRequireDefault(require("./Shortcode"));

var _types = require("../../types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import { Text, Inline } from 'slate';
const plugins = ({
  getAsset,
  resolveWidget
}) => [{
  onKeyDown(event, editor, next) {
    if ((0, _isHotkey.default)('mod+j', event)) {
      console.log(JSON.stringify(editor.value.document.toJS(), null, 2));
    }

    next();
  }

}, (0, _CommandsAndQueries.default)({
  defaultType: _types.SLATE_DEFAULT_BLOCK_TYPE
}), (0, _QuoteBlock.default)({
  defaultType: _types.SLATE_DEFAULT_BLOCK_TYPE,
  type: 'quote'
}), (0, _List.default)({
  defaultType: _types.SLATE_DEFAULT_BLOCK_TYPE,
  unorderedListType: 'bulleted-list',
  orderedListType: 'numbered-list'
}), (0, _Link.default)({
  type: 'link'
}), (0, _LineBreak.default)(), (0, _BreakToDefaultBlock.default)({
  defaultType: _types.SLATE_DEFAULT_BLOCK_TYPE
}), (0, _CloseBlock.default)({
  defaultType: _types.SLATE_DEFAULT_BLOCK_TYPE
}), (0, _SelectAll.default)(), (0, _ForceInsert.default)({
  defaultType: _types.SLATE_DEFAULT_BLOCK_TYPE
}), (0, _CopyPasteVisual.default)({
  getAsset,
  resolveWidget
}), (0, _Shortcode.default)({
  defaultType: _types.SLATE_DEFAULT_BLOCK_TYPE
})];

var _default = plugins;
exports.default = _default;